
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/documentServices/dsDebugTools/dsDebugger.scss.css.virtualfile';
        module.exports = {"container":"_container_1ujlx_1"};